import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/controls/Button"
import { ResultListMode } from "@components/layout/ResultList"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { IconCaretRight } from "@components/svg/Icons"
import { Link } from "eddev/routing"
import { ReactNode } from "react"
import { HallOfFameCardFragment } from "../../types.graphql"

type Props = HallOfFameCardFragment & {
  mode?: ResultListMode
}

export function HallOfFameCard(props: Props) {
  const meta = [] as ReactNode[]

  if (props.mode === "row") {
    return (
      <Link href={props.uri} className="grid-auto @container grid-flow-col border-t pt-4 pb-4 text-pretty">
        <div className="col-span-3 order-1 @xl:order-none @xl:col-span-1">
          <ResponsiveImage aspect={5 / 3} {...props.hero?.image!} />
        </div>
        <div className="col-span-9 @xl:col-span-4">
          <div className="type-title-xs-medium @xl:type-title-s-medium antialiased">{props.title}</div>
          <div className="type-body-s-roman text-grey whitespace-nowrap flex flex-wrap my-2 @xl:my-1 gap-x-3">
            {meta}
          </div>
        </div>
        <div className="hidden @xl:block @xl:col-span-5">
          <div className="type-body-s-roman line-clamp-3">{props.shortDescription}</div>
        </div>
        <div className="hidden @xl:flex justify-end @xl:col-span-2">
          <Button variant="outline" rightIcon={<IconCaretRight />}>
            Read More
          </Button>
        </div>
      </Link>
    )
  } else {
    return (
      <Link href={props.uri} className="block mb-7 group">
        <RouteFlipped flipId={props.id!}>
          <ResponsiveImage aspect={5 / 3} fadeOnLoad={false} {...props.hero?.image!} />
        </RouteFlipped>
        <div className="stack-y-1 pt-2">
          {!!meta.length && <div className="flex flex-wrap type-ui-s-roman text-grey gap-x-3 gap-y-1">{meta}</div>}
          <div className="stack-y">
            <div className="type-title-xs-medium md:type-title-s-medium antialiased text-pretty group-hover:text-grey-dark">
              {props.title}
            </div>
            {!!props.subtitle && <div className="type-title-s-light antialiased text-pretty">{props.subtitle}</div>}
          </div>
          <div className="pt-1 type-body-s-roman line-clamp-2">{props.shortDescription}</div>
        </div>
      </Link>
    )
  }
}
